import {
    FETCH_ACTIONS_REQUEST,
    FETCH_ACTIONS_SUCCESS,
    FETCH_ACTIONS_FAILURE,
} from './types/actions-action-types';

import MimirService from '../services/mimir-service';

function fetchActionsRequest(){
    return {
        type: FETCH_ACTIONS_REQUEST,
    };
}

function fetchActionsSuccess( actions ){
    return {
        actions,
        type: FETCH_ACTIONS_SUCCESS,
    };
}

function fetchActionsFailure( error ){
    return {
        error,
        type: FETCH_ACTIONS_FAILURE,
    };
}

export function fetchActions( domains = [] ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchActionsRequest() );
        const api = new MimirService( DATA_API );
        const params = {
            domains
        };

        return api.getActions( params ).then(
            ( actions ) => dispatch( fetchActionsSuccess( actions ) ),
            ( error ) => dispatch( fetchActionsFailure( error ) )
        );
    };
}

